module.exports = __webpack_public_path__ + "static/media/what_img4.51dcb380.webp";